import { ExploreElementType } from '../../../spinnaxBase/data/explore';

export const getMockEvents = () => {
  return [
    {
      id: 'event_1',
      name: 'Weltmeisterschaft 2024',
      type: ExploreElementType.Event,
      date: new Date(),
      favorite: false,
      location: 'Berlin',
      nationality: 'Germany',
      country: 'Germany', // Hinzugefügt
      gender: 'Male',
      age: 25,
      latitude: 52.52,
      longitude: 13.405,
      // Entferne Event-spezifische Eigenschaften, die nicht im ExploreElement Interface sind
    },
    {
      id: 'event_2',
      name: 'Street League Championship',
      type: ExploreElementType.Event,
      date: new Date(Date.now() - 86400000),
      favorite: true,
      location: 'Los Angeles',
      nationality: 'USA',
      country: 'USA', // Hinzugefügt
      gender: 'Male',
      age: 30,
      latitude: 34.0522,
      longitude: -118.2437,
    },
    {
      id: 'event_3',
      name: 'X-Games Barcelona',
      type: ExploreElementType.Event,
      date: new Date(Date.now() - 172800000),
      favorite: false,
      location: 'Barcelona',
      nationality: 'Spain',
      country: 'Spain',
      gender: 'Male',
      age: 28,
      latitude: 41.3851,
      longitude: 2.1734,
    },
    {
      id: 'event_4',
      name: 'Tokyo Street Open',
      type: ExploreElementType.Event,
      date: new Date(Date.now() + 86400000),
      favorite: false,
      location: 'Tokyo',
      nationality: 'Japan',
      country: 'Japan',
      gender: 'Male',
      age: 26,
      latitude: 35.6762,
      longitude: 139.6503,
    },
    {
      id: 'event_5',
      name: 'European Bowl Championship',
      type: ExploreElementType.Event,
      date: new Date(Date.now() + 259200000),
      favorite: false,
      location: 'Copenhagen',
      nationality: 'Denmark',
      country: 'Denmark',
      gender: 'Male',
      age: 22,
      latitude: 55.6761,
      longitude: 12.5683,
    },
  ];
};

export const getMockRankings = () => {
  return [
    {
      id: 'ranking-1',
      name: 'December Run Contest',
      type: ExploreElementType.Ranking,
      date: new Date('2024-12-01'),
      favorite: true,
      country: 'Global',
      location: 'Online',
      nationality: 'Global',
      gender: 'Male',
      age: 0,
      description: 'Monatlicher Run-Wettbewerb für die besten Skater weltweit.',
      rankingCategory: 'Monthly Contest',
      rankingPeriod: 'December 2024',
      maxParticipants: 500,
      isLive: true,
      rankings: [
        {
          userId: 'user-1',
          userName: 'Alex Rodriguez',
          score: 9850,
          position: 1,
          profileImageUrl: '/assets/images/profiles/alex.jpg',
          nationality: 'Spain',
        },
        {
          userId: 'user-2',
          userName: 'Maria Schmidt',
          score: 9720,
          position: 2,
          profileImageUrl: '/assets/images/profiles/maria.jpg',
          nationality: 'Germany',
        },
        {
          userId: 'user-3',
          userName: 'Chen Wei',
          score: 9680,
          position: 3,
          profileImageUrl: '/assets/images/profiles/chen.jpg',
          nationality: 'China',
        },
        {
          userId: 'user-4',
          userName: 'Jake Thompson',
          score: 9520,
          position: 4,
          profileImageUrl: '/assets/images/profiles/jake.jpg',
          nationality: 'USA',
        },
        {
          userId: 'user-5',
          userName: 'Sophie Dubois',
          score: 9480,
          position: 5,
          profileImageUrl: '/assets/images/profiles/sophie.jpg',
          nationality: 'France',
        },
      ],
    },

    {
      id: 'ranking-2',
      name: 'European Championship',
      type: ExploreElementType.Ranking,
      date: new Date('2024-11-20'),
      favorite: false,
      country: 'Europe',
      location: 'Various',
      nationality: 'European',
      gender: 'Male',
      age: 0,
      description:
        'Europäische Meisterschaft mit den besten Runs aus ganz Europa.',
      rankingCategory: 'Championship',
      rankingPeriod: 'Q4 2024',
      maxParticipants: 200,
      isLive: false,
      rankings: [
        {
          userId: 'user-6',
          userName: 'Luca Rossi',
          score: 9950,
          position: 1,
          profileImageUrl: '/assets/images/profiles/luca.jpg',
          nationality: 'Italy',
        },
        {
          userId: 'user-7',
          userName: 'Emma Johnson',
          score: 9890,
          position: 2,
          profileImageUrl: '/assets/images/profiles/emma.jpg',
          nationality: 'UK',
        },
        {
          userId: 'user-8',
          userName: 'Henrik Larsson',
          score: 9830,
          position: 3,
          profileImageUrl: '/assets/images/profiles/henrik.jpg',
          nationality: 'Sweden',
        },
      ],
    },
  ];
};

export const getMockPersons = () => {
  return [
    {
      id: 'person_1',
      name: 'Tony Hawk',
      type: ExploreElementType.Person,
      date: new Date(),
      favorite: true,
      location: 'California',
      nationality: 'American',
      country: 'USA', // Hinzugefügt
      gender: 'Male',
      age: 55,
    },
    {
      id: 'person_2',
      name: 'Nyjah Huston',
      type: ExploreElementType.Person,
      date: new Date(),
      favorite: false,
      location: 'California',
      nationality: 'American',
      country: 'USA', // Hinzugefügt
      gender: 'Male',
      age: 29,
    },
    {
      id: 'person_3',
      name: 'Leticia Bufoni',
      type: ExploreElementType.Person,
      date: new Date(),
      favorite: true,
      location: 'Sao Paulo',
      nationality: 'Brazilian',
      country: 'Brazil', // Hinzugefügt
      gender: 'Female',
      age: 31,
    },
    {
      id: 'person_4',
      name: 'Rodney Mullen',
      type: ExploreElementType.Person,
      date: new Date(),
      favorite: true,
      location: 'Florida',
      nationality: 'American',
      country: 'USA', // Hinzugefügt
      gender: 'Male',
      age: 57,
    },
    {
      id: 'person_5',
      name: 'Daewon Song',
      type: ExploreElementType.Person,
      date: new Date(),
      favorite: false,
      location: 'Los Angeles',
      nationality: 'American',
      country: 'USA', // Hinzugefügt
      gender: 'Male',
      age: 49,
    },
  ];
};

export const getMockAIAgents = () => {
  return [
    {
      id: 'ai_1',
      name: 'SkateBot Pro',
      type: ExploreElementType.Ai,
      date: new Date(),
      favorite: false,
      location: 'Cloud',
      nationality: 'Digital',
      country: 'Digital', // Hinzugefügt
      gender: 'AI',
      age: 0, // Default für AI
    },
    {
      id: 'ai_2',
      name: 'Run Analyze',
      type: ExploreElementType.Ai,
      date: new Date(),
      favorite: true,
      location: 'Cloud',
      nationality: 'Digital',
      country: 'Digital', // Hinzugefügt
      gender: 'AI',
      age: 0,
    },
    {
      id: 'ai_3',
      name: 'Style Coach AI',
      type: ExploreElementType.Ai,
      date: new Date(),
      favorite: false,
      location: 'Cloud',
      nationality: 'Digital',
      country: 'Digital', // Hinzugefügt
      gender: 'AI',
      age: 0,
    },
    {
      id: 'ai_4',
      name: 'Competition Judge AI',
      type: ExploreElementType.Ai,
      date: new Date(),
      favorite: false,
      location: 'Cloud',
      nationality: 'Digital',
      country: 'Digital', // Hinzugefügt
      gender: 'AI',
      age: 0,
    },
  ];
};

export const getMockContests = () => {
  return [
    {
      id: 'contest_1',
      name: 'Winter Championship 2025',
      type: ExploreElementType.Contest,
      date: new Date('2025-01-15'),
      favorite: true,
      country: 'Global',
      location: 'Online',
      nationality: 'Global',
      gender: 'Male',
      age: 0,
      description: 'Internationaler Winter-Contest mit den besten Runs.',
      maxRuns: 5,
      contestRules:
        'Best 3 out of 5 runs count. Street and park tricks allowed.',
      isContestActive: true,
      rankings: [
        {
          userId: 'contest-user-1',
          userName: 'Alex Thunder',
          score: 95.5,
          position: 1,
          profileImageUrl: '/assets/images/profiles/alex-thunder.jpg',
          nationality: 'USA',
        },
        {
          userId: 'contest-user-2',
          userName: 'Nina Storm',
          score: 92.8,
          position: 2,
          runCount: 4,
          profileImageUrl: '/assets/images/profiles/nina-storm.jpg',
          nationality: 'Germany',
        },
        {
          userId: 'current-user-mock', // Simulate current user participation
          userName: 'Current User',
          score: 89.5,
          position: 3,
          runCount: 2,
          profileImageUrl: '/assets/images/profiles/current-user.jpg',
          nationality: 'Germany',
        },
        {
          userId: 'contest-user-3',
          userName: 'Carlos Fire',
          score: 87.2,
          position: 4,
          runCount: 3,
          profileImageUrl: '/assets/images/profiles/carlos-fire.jpg',
          nationality: 'Spain',
        },
      ],
    },
    {
      id: 'contest_2',
      name: 'Spring Street Series',
      type: ExploreElementType.Contest,
      date: new Date('2025-03-01'),
      favorite: false,
      country: 'Europe',
      location: 'Barcelona',
      nationality: 'Spain',
      gender: 'Male',
      age: 0,
      description: 'Street-only Contest in den Straßen von Barcelona.',
      maxRuns: 3,
      contestRules: 'Street tricks only. Best single run counts.',
      isContestActive: false,
      rankings: [],
    },
    {
      id: 'contest_3',
      name: 'Summer Bowl Battle',
      type: ExploreElementType.Contest,
      date: new Date('2025-06-01'),
      favorite: true,
      country: 'USA',
      location: 'Venice Beach',
      nationality: 'USA',
      gender: 'Male',
      age: 0,
      description: 'Epischer Bowl-Contest am Venice Beach.',
      maxRuns: 4,
      contestRules: 'Bowl tricks only. Combined score of best 2 runs.',
      isContestActive: false,
      rankings: [],
    },
    {
      id: 'contest_4',
      name: 'Autumn Freestyle Challenge',
      type: ExploreElementType.Contest,
      date: new Date('2025-09-15'),
      favorite: false,
      country: 'Canada',
      location: 'Toronto',
      nationality: 'Canada',
      gender: 'Male',
      age: 0,
      description: 'Freestyle Contest mit kreativen Runs und Kombinationen.',
      maxRuns: 3,
      contestRules: 'Freestyle tricks. Creativity and originality count.',
      isContestActive: false,
      rankings: [],
    },
    {
      id: 'contest_5',
      name: 'Urban Night Session',
      type: ExploreElementType.Contest,
      date: new Date('2025-07-20'),
      favorite: true,
      country: 'Japan',
      location: 'Tokyo',
      nationality: 'Japan',
      gender: 'Male',
      age: 0,
      description: 'Nächtlicher Urban Contest in den Straßen von Tokyo.',
      maxRuns: 2,
      contestRules: 'Night session rules. Style over technical difficulty.',
      isContestActive: false,
      rankings: [],
    },
    {
      id: 'contest_6',
      name: 'World Championship Finals',
      type: ExploreElementType.Contest,
      date: new Date('2025-12-01'),
      favorite: true,
      country: 'Global',
      location: 'Los Angeles',
      nationality: 'Global',
      gender: 'Male',
      age: 0,
      description: 'Das große Finale der Weltmeisterschaft.',
      maxRuns: 5,
      contestRules: 'Championship rules. Best 4 out of 5 runs count.',
      isContestActive: false,
      rankings: [],
    },
  ];
};

// Hilfsfunktion für Top Rankings
export const getTopRankings = (count: number = 10) => {
  return getMockRankings().slice(0, count);
};

// Hilfsfunktion für Rankings nach Kategorie
export const getRankingsByCategory = (category: string) => {
  return getMockRankings().filter((ranking) =>
    ranking.name.toLowerCase().includes(category.toLowerCase())
  );
};

// Hilfsfunktion für Favoriten-Rankings
export const getFavoriteRankings = () => {
  return getMockRankings().filter((ranking) => ranking.favorite);
};

// Kombinierte Funktion für alle Mock-Daten
export const getAllMockData = () => {
  return [
    ...getMockEvents(),
    ...getMockPersons(),
    ...getMockRankings(),
    ...getMockAIAgents(),
    ...getMockContests(),
  ];
};
